<template >
  <div class="accordion-box" :class="isClosed ? '' : 'show-less'">
    <div class="accordion-header" @click="handleClosed">
      <div class="title-container">
      <slot name="name" />
        <slot name="title" />
      </div>
        <span :class="isClosed ? '' : 'show-less'" class="show-more"></span>
    </div>
    <div :class="isClosed ? 'is-closed' : ''" class="accordion-body">
      <slot name="image" />

      <slot name="description" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isClosed: true,
    };
  },
  methods: {
    handleClosed() {
      this.isClosed = !this.isClosed;
    },
  },
};
</script>
